import { FC } from "react";
import { Box, IconButton } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import CheckIcon from "@mui/icons-material/Check";

import { Colors } from "../../../../configs";

interface BottomActionButtonsProps {
  onAddClick?: () => void;
  disable?: boolean;
}

const BottomActionButtons: FC<BottomActionButtonsProps> = ({
  onAddClick,
  disable,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.86rem",
        height: "5.85rem",
        minWidth: "13.57rem",
        borderRadius: "1.43rem",
        background: Colors.SECONDARY,
        boxShadow: "0 6px 16px rgba(0, 121, 194, 0.18)",
        overflow: "hidden",
      }}
    >
      <IconButton
        aria-label="Reset"
        sx={{
          width: "4rem",
          height: "4rem",
          borderRadius: "1.43rem",
          transition: "background-color 0.2s ease, transform 0.15s ease",
          "&:hover": {
            background: "rgba(255, 255, 255, 0.12)",
          },
          "&:active": {
            transform: "scale(0.95)",
          },
        }}
      >
        <ReplayIcon style={{ fontSize: "2.57rem", color: Colors.WHITE }} />
      </IconButton>

      <Box
        sx={{
          width: "1px",
          height: "3.43rem",
          background: Colors.WHITE,
          opacity: 0.25,
        }}
      />

      <IconButton
        aria-label="Confirm"
        sx={{
          width: "4rem",
          height: "4rem",
          borderRadius: "1.43rem",
          transition: "background-color 0.2s ease, transform 0.15s ease",
          "&:hover": {
            background: "rgba(255, 255, 255, 0.12)",
          },
          "&:active": {
            transform: "scale(0.95)",
          },
          "&.Mui-disabled": {
            opacity: 0.5,
          },
        }}
        disabled={disable}
        onClick={onAddClick}
      >
        <CheckIcon style={{ fontSize: "2.57rem", color: Colors.WHITE }} />
      </IconButton>
    </Box>
  );
};

export default BottomActionButtons;
